<template>
  <a-modal
    title="编辑"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading || dataLoading">
      <a-form :form="form">
        <a-form-item label="淘宝联盟账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['taobao_user_nick', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
            read-only
          />
        </a-form-item>
        <a-form-item label="账户ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['taobao_user_id', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
            read-only
          />
        </a-form-item>
        <a-form-item label="AccessToken" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['access_token', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
            read-only
          />
        </a-form-item>
        <a-form-item label="备注信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['remarks_text', {rules: [{required: true, message: '必填项'}]}]" placeholder="请填写" />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button
        :loading="confirmLoading"
        :disabled="dataLoading"
        type="primary"
        @click="handleSubmit"
      >确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import CompanyApi from '@/api/company'
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      id: null,
      dataLoading: true
    }
  },
  methods: {
    show(id) {
      this.id = id
      this.visible = true
      this.getData()
    },
    getData() {
      this.dataLoading = true
      CompanyApi.getTaobaoById(this.id)
        .then(res => {
          if (res.code === 1) {
            this.form.setFieldsValue({
              taobao_user_nick: res.data['taobao_user_nick'],
              taobao_user_id: res.data['taobao_user_id'],
              access_token: res.data['access_token'],
              remarks_text: res.data['remarks_text']
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          CompanyApi.setTaobaoInfo({
            id: this.id,
            remark: values.remarks_text
          })
            .then(res => {
              if (res.code === 1) {
                this.form.resetFields()
                this.$message.success('操作成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
